export const AllStatType = {
    stat_illegal_count: {
        key: 'stat_illegal_count',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    electron_init_time: {
        key: 'electron_init_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    electron_create_window_time: {
        key: 'electron_create_window_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        checkFn: params => params.value < 1000 * 60 * 10,
    },
    dom_all_time: {
        key: 'dom_all_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    long_task_record_duration: {
        key: 'long_task_record_duration',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        checkFn: params => params.value < 1000 * 300,
    },
    long_task_record_count: {
        key: 'long_time_task_count',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        checkFn: params => params.value < 10000,
        type: 'count',
    },
    pr_blink_mem: {
        key: 'pr_blink_mem',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    pr_heap_mem: {
        key: 'pr_heap_mem',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    pr_proc_mem: {
        key: 'pr_proc_mem',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    pr_cpu_rate: {
        key: 'pr_cpu_rate',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    pr_io_counts: {
        key: 'pr_io_counts',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        increasingRecord: true,
    },
    web_memory: {
        key: 'web_memory',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    dom_interactive: {
        key: 'dom_interactive',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    dom_load_event: {
        key: 'dom_load_event',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    page_remove_loading: {
        key: 'page_remove_loading',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_upload_speed: {
        key: 'mail_attachment_upload_speed',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_download_speed: {
        key: 'mail_attachment_download_speed',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_upload_time: {
        key: 'mail_attachment_upload_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_upload_times: {
        key: 'mail_attachment_upload_times',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_uploading: {
        key: 'mail_attachment_uploading',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_attachment_download_time: {
        key: 'mail_attachment_download_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_search_load_time: {
        key: 'mail_search_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_write_load_time: {
        key: 'mail_write_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        crossWindow: true,
    },
    mail_content_inner_load_time: {
        key: 'mail_content_inner_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    mail_content_window_load_time: {
        key: 'mail_content_window_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        crossWindow: true,
    },
    mail_content_push_load_time: {
        key: 'mail_content_push_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
        crossWindow: true,
    },
    mail_list_load_time: {
        key: 'mail_list_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    schedule_data_handle: {
        key: 'schedule_data_handle',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    schedule_data_render: {
        key: 'schedule_data_render',
        desc: process.env.NODE_ENV !== 'development' ? '' : '日历加载时长',
    },
    mail_listclick_content_load_time: {
        key: 'mail_listclick_content_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '邮件列表从点击-到正文加载完成的时间',
    },
    contact_search_time: {
        key: 'contact_search_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    contact_load_time: {
        key: 'contact_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '',
    },
    fs_download: {
        key: 'fs_download',
        desc: process.env.NODE_ENV !== 'development' ? '' : '文件下载',
    },
    login: {
        key: 'login',
        desc: process.env.NODE_ENV !== 'development' ? '' : '登录耗时相关打点',
    },
    login_ev: {
        key: 'login_ev',
        desc: process.env.NODE_ENV !== 'development' ? '' : '登录错误相关打点',
    },
    re_login: {
        key: 're_login',
        desc: process.env.NODE_ENV !== 'development' ? '' : '自动重登录耗时相关打点',
    },
    re_login_ev: {
        key: 're_login_ev',
        desc: process.env.NODE_ENV !== 'development' ? '' : '自动重登录错误相关打点',
    },
    mail_ui_content_load_time: {
        key: 'mail_ui_content_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '普通邮件从收到id到正文展示花费的时间',
    },
    mail_list_load_timeout: {
        key: 'mail_list_load_timeout',
        desc: process.env.NODE_ENV !== 'development' ? '' : '邮件列表的加载超时，包含正常列表，搜索，聚合列表，高级搜索，从db加载等所有影响列表加载的请求',
    },
    total_process_memory_used: {
        key: 'total_process_memory_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '所有进程的内存使用量',
    },
    gpu_process_memory_used: {
        key: 'gpu_process_memory_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : 'GPU进程的内存使用量',
    },
    main_process_memory_used: {
        key: 'main_process_memory_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '主进程的内存使用量',
    },
    utility_process_memory_used: {
        key: 'utility_process_memory_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '服务进程的内存使用量',
    },
    render_process_count: {
        key: 'render_process_count',
        desc: process.env.NODE_ENV !== 'development' ? '' : '渲染器进程的数量',
    },
    main_process_cpu_used: {
        key: 'main_process_cpu_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '自上次上报依赖主进程的CPU累计使用量',
    },
    gpu_process_cpu_used: {
        key: 'gpu_process_cpu_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '自上次上报依赖GPU进程的CPU累计使用量',
    },
    utility_process_cpu_used: {
        key: 'utility_process_cpu_used',
        desc: process.env.NODE_ENV !== 'development' ? '' : '自上次上报依赖服务进程的CPU累计使用量',
    },
    mail_list_request_load_time: {
        key: 'mail_list_request_load_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '邮件列表的加载时间，包含正常列表，搜索，聚合列表，高级搜索，从db加载等所有影响列表加载的请求',
    },
    update_refreshToken: {
        key: 'update_refreshToken',
        desc: process.env.NODE_ENV !== 'development' ? '' : 'refreshToken过期3天内更新refreshToken的结果',
    },
    jump_page_err_showed: {
        key: 'jump_page_err_showed',
        desc: process.env.NODE_ENV !== 'development' ? '' : 'webmail登陆失败',
    },
    jump_page_bt_clicked: {
        key: 'jump_page_bt_clicked',
        desc: process.env.NODE_ENV !== 'development' ? '' : 'webmail登陆失败按钮',
    },
    jump_page_stay_span: {
        key: 'jump_page_stay_span',
        desc: process.env.NODE_ENV !== 'development' ? '' : 'webmail跳转页停留时长',
    },
    write_mail_load: {
        key: 'write_mail_load',
        desc: process.env.NODE_ENV !== 'development' ? '' : '打点时长记录',
    },
    side_bar_click_time: {
        key: 'side_bar_click_time',
        desc: process.env.NODE_ENV !== 'development' ? '' : '侧边栏切换模块响应速度',
    },
    mail_readmail_switch: {
        key: 'mail_readmail_switch',
        desc: process.env.NODE_ENV !== 'development' ? '' : '切换邮件时长',
    },
    mail_folder_switch_start: {
        key: 'mail_folder_switch_start',
        desc: process.env.NODE_ENV !== 'development' ? '' : '切换邮件列表时长',
    },
    write_mail_search_contact: {
        key: 'write_mail_search_contact',
        desc: process.env.NODE_ENV !== 'development' ? '' : '通讯录搜索',
    },
};
